function mapReplacer(_key: string, value: any): any {
    if (value instanceof Map) {
        return { __type: "Map", entries: Array.from(value.entries()) }
    }
    return value
}

function mapReviver(_key: string, value: any): any {
    if (value && typeof value === "object" && value.__type === "Map") {
        return new Map(value.entries)
    }
    return value
}

export const JSONStringify = (value: any) => {
    return JSON.stringify(value, mapReplacer)
}

export const JSONParse = (value: any) => {
    return JSON.parse(value, mapReviver)
}
